export default __webpack_public_path__ + "static/media/main-characters-padded.a8918be4.jpg";